import createRestfulModule from './restful-module'
import _ from 'lodash'

export default createRestfulModule({

  state: {
    path: 'products', // 资源路径
    defaultRels: ['productSpecs', 'category'], // 默认需要的关联数据
  },
  getters: {
    collection: (state) => {
      let collection = state.collection.collection
      collection = collection.map((product) => {
        product.productSpecs = product.productSpecs.map((productSpec) => {
          let photos = _.cloneDeep(productSpec.photos)
          let photo = ''
          if(photos && photos.length > 0) {
            photos = photos.filter(item => !item.isDeleted)
            if(photos && photos.length > 0) {
              photo = photos[0].url
            }else{
              photo = require('../../assets/no-image.jpg')

            }
          }else{
            photo = require('../../assets/no-image.jpg')
          }
          productSpec.photo = photo
          return productSpec
        })
        return product
      })
      return state.collection.collection
    }
  }

})
